<mat-form-field floatLabel="always" class="structure-selector">
  <mat-label ddcLabel labelKey="{{_labelKey}}"></mat-label>
  <input matInput [matAutocomplete]="auto" [formControl]="_structureFormControl" required="{{_isRequired}}"/>
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayStructureName.bind(this)">
    <mat-option *ngFor="let structure of filteredStructures$ | async" [value]="structure">
      <span>{{structure.code}} - {{structure.libelle}}</span>
    </mat-option>
  </mat-autocomplete>
  <mat-error ddcMatError [control]="_structureFormControl"></mat-error>
</mat-form-field>
